import * as yup from 'yup';

const {
    string, number, object, date,
} = yup;

const PurchaseOrderSchema = object().shape({
    shippingMethodId: number().required().moreThan(0, 'Shipping method is required'),
    vendorId: number().required().moreThan(0, 'Vendor id required'),
    partsClerk: string(),
    status: string().max(12),
    lotName: string().required('Lot is required'),
    salesTaxRate: number(),
    reference: string().nullable(),
    orderDate: date().nullable().required('Order date required'),
    deliveryDate: date().nullable().required('Delivery date required'),
    notes: string().max(
        4000,
        'Notes must be at most 4000 characters',
    ),
});

export default PurchaseOrderSchema;
